export const sessionStorageKeys = {
    lastPosition: "lastPosition"
};
